import * as React from 'react'

import Button from '../button'
import SearchLink from '../../containers/searchLinkContainer'

import * as styles from './pillsNav.module.css'

interface IPillNavProps {
  children: React.ReactNode
}
interface IPillsNav extends React.SFC<IPillNavProps> {
  Pill: typeof Pill
}

const Pill: React.SFC<any> = ({ children, ...props }) => (
  <li className={styles.listElement}>
    <Button {...props} renderAs={SearchLink} type={Button.Type.Pill}>
      {children}
    </Button>
  </li>
)

const PillsNav: IPillsNav = ({ children }) => (
  <ul className={styles.root}>{children}</ul>
)

PillsNav.Pill = Pill

export default PillsNav
